import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { parameterizePath, trackView } from './countly';

/**
 * Subscribes to React Router v5 location changes and records each
 * navigation as a Countly page view. Mount exactly once inside <Router>.
 *
 * Strict-Mode safe: a ref prevents duplicate tracking when the effect
 * fires twice with the same pathname.
 */
export function useCountlyViews(): void {
  const { pathname } = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (prevPathRef.current === pathname) {
      return;
    }
    prevPathRef.current = pathname;
    trackView(parameterizePath(pathname));
  }, [pathname]);
}
